import { MAT_DIALOG_DATA } from "@angular/material";
import { TranslateService } from "@ngstack/translate";
import { MatDialogRef } from "@angular/material/dialog";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Component, OnInit, Inject } from "@angular/core";

import { SoundEnum } from "src/app/enums/sound.enum";
import { IPlacement } from "src/app/interfaces/placement";
import { ILevelInfo } from "src/app/interfaces/levelInfo";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { ContractService } from "src/app/services/http/business/contract/contract.service";
import { PlacementService } from "src/app/services/http/business/placement/placement.service";
import { LevelInfoService } from "src/app/services/http/business/levelInfo/level-info.service";
import { ErrorsService } from "src/app/services/common/errors.service";
import { BIDService } from "src/app/services/common/bid.service";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: "app-confirm-placement-entry",
  templateUrl: "./confirm-placement-entry.component.html",
  styleUrls: ["./confirm-placement-entry.component.css"]
})
export class ConfirmPlacementEntryComponent implements OnInit {
  param: any;
  errorList: IError[] = [];
  errObject: any;
  form: FormGroup;
  placementTeacherMain;
  placementTeacher;
  errors = new Array();
  levelsList: ILevelInfo[];
  reservationInfo: IPlacement;
  isOwner: boolean;
  constructor(
    private fb: FormBuilder,
    private snackBar: SnackBarService,
    private translate: TranslateService,
    private errorService: ErrorsService,
    private contractService: ContractService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private placementService: PlacementService,
    private bidService: BIDService,
    private holdingService: HoldingService,
    private LevelInfoService: LevelInfoService,
    private dialog: MatDialogRef<ConfirmPlacementEntryComponent>
  ) { }

  ngOnInit() {
    console.log(this.data);

    this.checkOwner();
    // if (this.isOwner)
    //   this.bidService.setBID(this.data.BranchEncryptId);
    this.createForm();
    this.getLevels();
    this.getReservationInfo();
    this.getPlacementTeacher();
  }
  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      if (res.IsOwner)
        this.bidService.setBID(this.data.BranchEncryptId);
    });
  }

  createForm() {
    this.form = this.fb.group({
      Id: [null],
      UserEncryptId: [null, Validators.compose([Validators.required])],
      PackageId: [null],
      LevelId: [null, Validators.compose([Validators.required])],
      MarketerCode: [null],
      FirstName: [null],
      LastName: [null]
    });

    if (this.data.LevelInfoId) {
      this.form.controls['LevelId'].setValue(this.data.LevelInfoId.toString());
      this.form.controls['UserEncryptId'].setValue(this.data.TeacherUserEncryptId);
      this.form.controls['PackageId'].setValue(this.data.PackageId);
      this.form.controls['Id'].setValue(this.data.Id);
    }
  }
  filterOptione(key) {
    this.placementTeacher = this.placementTeacherMain.filter(function (e) {
      return e.FirstName.includes(key) || e.LastName.includes(key)
    })
  }
  getReservationInfo() {
    this.placementService.getById(this.data.Id).subscribe(res => {
      this.reservationInfo = res;
      this.form.controls.FirstName.setValue(this.reservationInfo.FirstName);
      this.form.controls.LastName.setValue(this.reservationInfo.LastName);
      this.form.controls.PackageId.setValue(this.reservationInfo.PackageId);
      this.form.controls.Id.setValue(this.reservationInfo.Id);
    });
  }

  getLevels() {
    this.LevelInfoService.getActiveList(this.data.PackageId).subscribe(res => {
      this.levelsList = res.DataList;
    });
  }

  getPlacementTeacher() {
    this.contractService.getListPlacementInBranch(this.data.BranchEncryptId, 0, 0).subscribe(res => {
      this.placementTeacherMain = res.DataList;
      this.placementTeacher = res.DataList;
    });
  }

  onClose() {
    this.dialog.close();
  }

  submit(data: IPlacement) {
    this.errors = new Array();
    this.placementService.setPlacement(data).subscribe(
      () => {
        this.dialog.close(true);
        this.snackBar.OpenSnackBar(
          this.translate.get("success.registration"),
          "ok",
          5000,
          SoundEnum.beep
        );
      },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error)
      }
    );
  }
}
